import type { Analytics } from '../analytics/types';

import { Flow, type LoginOptions, type RegisterOptions } from './types';
import getWebAuth from './utils/getWebAuth';
import { mapError } from './utils/mapError';

const register = (
  { trackLink }: Analytics,
  {
    newEmailAddress: emailAddress,
    newPassword: password,
    connection,
    captchaToken,
    language,
    locale,
    privacyAccepted,
    marketingAccepted,
  }: RegisterOptions,
): Promise<LoginOptions> =>
  new Promise((resolve, reject) => {
    const conn = connection;
    const userMetadata = {
      ...(captchaToken && { recaptcha_token: captchaToken }),
      ...(privacyAccepted && { privacy_accepted: 'true' }),
      ...(marketingAccepted && { marketing_accepted: 'true' }),
      preferredLanguage: language,
      preferredLocale: locale,
      createdFromUI: 'true',
    };

    const webAuth = getWebAuth();
    webAuth.signup(
      {
        email: emailAddress,
        password,
        userMetadata,
        connection: conn,
      },
      (error) => {
        if (error) {
          const reason = mapError(error, trackLink, 'register.error');
          reject(reason);
          return;
        }

        // resolve login option for promise chaining
        resolve({
          emailAddress,
          password,
          realm: conn,
          flow: Flow.Register,
        });
      },
    );
  });

export default register;
